export default {
  checkout: 'Checkout',
  altSpc: 'Alt SPC'
};
